/*
 *
 *  selectors
 *
 */

import { createSelector } from 'reselect'
import key from './key'
import mapRecords from './utils'

const name = atob(key)

export const selectDomain = () => (state) => {
  console.log(state[name])
  return state[name] || false}

export const selectLoading = () => createSelector(
  selectDomain(),
  (domain) => domain && domain.loading || false,
)

export const selectRecordsMetaData = () => createSelector(
  selectDomain(),
  (domain) => domain && domain.recordsMetaData || {},
)

export const selectRecords = () => createSelector(
  selectDomain(),
  (domain) => {
    console.log(domain)
    return domain && domain.records && mapRecords(domain.records, name) || [] }
)

export const selectRecord = () => createSelector(
  selectDomain(),
  (domain) => domain && domain.record && mapRecords([domain.record], name)[0] || {}
)

export const selectError = () => createSelector(
  selectDomain(),
  (domain) => domain && (domain.error || domain.pageError || false),
)

export const selectSuccess = () => createSelector(
  selectDomain(),
  (domain) => domain && domain.success || false,
)

export const selectUpdateTimestamp = () => createSelector(
  selectDomain(),
  (domain) => domain && domain.lastUpdate || false,
)

export const selectPageAccess = (path) => (state) => {

  const menu = state && state.session && state.session.user && state.session.user.menu || {}
  const getAccess = menu && Array.isArray(menu) && menu.length > 0 ? menu.find(el => 
    el.menuId && 
    el.menuId.menuSubHeader && 
    el.menuId.menuSubHeader.length > 0 && 
    el.menuId.menuSubHeader.find(_ => 
      _.menuId && 
      path && 
      (_.menuId.menukey == path || 
        _.menuId.menukey == path.substring(1) || 
        (_.menuId.menuItem && _.menuId.menuItem.length > 0 && 
        _.menuId.menuItem.find(v => 
          v.menuId && 
          v.menuId.menukey == path))))) : []
  const pageAccess = getAccess && Object.keys(getAccess).length > 0 && getAccess.access && getAccess.access.map(_ => _.accessName) || []
  return pageAccess
}

const selectors = {
  selectDomain,
  selectLoading,
  selectRecords,
  selectRecordsMetaData,
  selectRecord,
  selectError,
  selectSuccess,
  selectUpdateTimestamp,
  selectPageAccess
}

export default selectors

